import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-emission-report-results',
  templateUrl: './emission-report-results.component.html',
  styleUrls: ['./emission-report-results.component.scss']
})
export class EmissionReportResultsComponent {

  constructor(
    public dialogRef: MatDialogRef<EmissionReportResultsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  isSimpleReport(): boolean {
    return typeof this.data?.report_file === 'string';
  }

  isPdfReport(): boolean {
    if (!this.isSimpleReport()) {
      return false;
    }
    const url = (this.data?.report_file || '').toLowerCase();
    const type = (this.data?.reportType || '').toUpperCase();
    if (['EUETS', 'UKMRV', 'MRV', 'FUELEU', 'EU_ETS', 'UK_MRV'].includes(type)) {
      return true;
    }
    return url.includes('.pdf');
  }

  getReportTitle(): string {
    const type = (this.data?.reportType || '').toUpperCase();
    switch (type) {
      case 'EUETS':
      case 'EU_ETS':
        return 'EU ETS Report';
      case 'UKMRV':
      case 'UK_MRV':
        return 'UK MRV Report';
      case 'MRV':
        return 'MRV Report';
      case 'FUELEU':
        return 'FuelEU Maritime Report';
      case 'IMO-DCS':
        return 'IMO DCS Detailed Report';
      default:
        return this.isPdfReport() ? 'Emission Report' : 'Detailed Report';
    }
  }

  getFileTypeLabel(): string {
    return this.isPdfReport() ? 'PDF Document' : 'Excel Workbook (XLSX)';
  }

  downloadFile(url: string) {
    if (!url) return;
    window.open(url, '_blank');
  }

  close() {
    this.dialogRef.close();
  }
}
